import React, { useCallback, useMemo } from 'react';
import { getColumns } from './columns';
import VirtualTable from 'components/VirtualTable/VirtualTable';
import EditUserModal from 'components/EditUserModal/EditUserModal';

export default function UsersTable({
  loading,
  warehouses,
  marketplaces,
  hasNextPage,
  users,
  groups,
  onLoadMoreItems = () => {},
  onUpdateUser = () => {},
}) {
  const renderActions = useCallback(
    (row) => {
      return (
        <EditUserModal
          initialData={row}
          warehouses={warehouses}
          marketplaces={marketplaces}
          onUpdateUser={onUpdateUser}
        />
      );
    },
    [warehouses, marketplaces, onUpdateUser],
  );

  const columns = useMemo(
    () => getColumns(groups, renderActions),
    [renderActions, groups],
  );

  return (
    <section style={{ overflow: 'hidden' }}>
      <VirtualTable
        loading={loading}
        tableClassNames="users-table"
        columns={columns}
        data={users}
        hasNextPage={hasNextPage}
        onLoadMoreItems={onLoadMoreItems}
      />
    </section>
  );
}
